/*
 * Copyright © 2021 Aram Meem Company Limited.  All Rights Reserved.
 */

import * as React from 'react';
import { PointOnMap } from '../models/point-on-map';
import { gPlaceToDeliveryAddress } from '../helpers';
import { GOOGLE_MAP_URL } from '../constants';
import { storeServiceInstance } from "../App";
import { debounce } from 'lodash';
import { MapWithMarker } from "./MapWithMarker";

declare const google: any;


interface Params {
  dropOffLocation: PointOnMap,
  pickUpGeoPoint: PointOnMap,
  setDeliveryAddress: any
}

export class SelectAddressMap extends React.PureComponent<Params, any> {

  private geocoder = null;
  private gmap: any = null;

  state = {
    currentLocation: null,
    dropOffLocation: new PointOnMap(),
    center: null,
    bounds: null,
    onPlacesChanged: null,
    onSearchBoxMounted: null
  };

  componentWillMount() {
    const refs = {
      searchBox: null,
    };

    let dropOffLocation = new PointOnMap();

    dropOffLocation.lat = this.props.pickUpGeoPoint.lat;
    dropOffLocation.lon = this.props.pickUpGeoPoint.lon - 0.0002; // that the markers do not match

    if (storeServiceInstance.customerSelectedAddress) {
      dropOffLocation = this.props.dropOffLocation;
    }

    this.setState({
      dropOffLocation,
      bounds: null,
      onSearchBoxMounted: ref => {
        refs.searchBox = ref;
        this.geocoder = new google.maps.Geocoder({location_type: 'RANGE_INTERPOLATED'});

        const autoCompleteBounds = new google.maps.LatLngBounds();
        autoCompleteBounds.extend({
          lat: this.props.pickUpGeoPoint.lat,
          lng: this.props.pickUpGeoPoint.lon
        });

        if (!storeServiceInstance.customerSelectedAddress) {
          this.setMyLocation();
        }

        this.setState({bounds: autoCompleteBounds});

      },
      onPlacesChanged: () => {
        const places = refs.searchBox.getPlaces();
        const bounds = new google.maps.LatLngBounds();

        places.forEach(place => {
          if (place.geometry.viewport) {
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        const nextMarkers = places.map(place => ({
          position: place.geometry.location,
        }));
        const nextCenter = nextMarkers && nextMarkers.length > 0 && nextMarkers[0]['position']
          ? nextMarkers[0]['position']
          : this.state.center;

        this.setPlace(nextCenter);

        this.setState({
          center: nextCenter,
          markers: nextMarkers,
          dropOffLocation: {lat: nextCenter.lat(), lon: nextCenter.lng()}
        });

      }
    });
  }


  setPlace = (latLng) => {

    this.geocoder.geocode({latLng}, (places, status) => {
      if (status === google.maps.GeocoderStatus.OK) {


        const targetPlace = places[0];

        if (targetPlace) {
          const pointOfMap = new PointOnMap();
          pointOfMap.lat = latLng.lat();
          pointOfMap.lon = latLng.lng();

          const t = gPlaceToDeliveryAddress(targetPlace, pointOfMap);

          this.props.setDeliveryAddress(t);


        }
      }
    });
  }

  setMyLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setPlace(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
          const coords = {lat: position.coords.latitude, lon: position.coords.longitude};
          this.setState({
            currentLocation: coords,
            dropOffLocation: coords
          });
        }
      );
    }
  }

  onCenterChanged = () => {
    this.centerChangedDebounce();
  }

  setPlaceAndDropOff = () => {
    this.setPlace(this.gmap.getCenter());
    this.state.dropOffLocation = {lat: this.gmap.getCenter().lat(), lon: this.gmap.getCenter().lng()};
  }

  centerChangedDebounce = debounce(this.setPlaceAndDropOff, 300);

  onMapMounted = map => {
    if (map) {
      this.gmap = map;
    }
  }


  render() {
    return (
      <div>
        <MapWithMarker
          currentLocation={this.state.currentLocation}
          dropOffLocation={this.state.dropOffLocation}
          onSearchBoxMounted={this.state.onSearchBoxMounted}
          onCenterChanged={this.onCenterChanged}
          onMapMounted={this.onMapMounted}
          bounds={this.state.bounds}
          onPlacesChanged={this.state.onPlacesChanged}
          googleMapURL={GOOGLE_MAP_URL}
          loadingElement={<div style={{height: `100%`, width: `100%`, position: 'absolute', top: 0, left: 0}}/>}
          containerElement={<div style={{height: `100%`, width: `100%`, position: 'absolute', top: 0, left: 0}}/>}
          mapElement={<div style={{height: `100%`, width: `100%`, position: 'absolute', top: 0, left: 0}}/>}
        />

        {
          this.state.currentLocation &&
          <button
            type="button"
            onClick={this.setMyLocation}
            className="geo_btn geo_btn--bottom_right geo_btn--upper"/>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/SelectAddressMap.tsx